/** Pagination envelope returned inside `data` by list endpoints. */
export interface PageMeta {
  page: number;
  limit: number;
  totalItems: number;
  totalPages: number;
}

export interface Page<T> {
  data: T[];
  meta: PageMeta;
}

export type SortOrder = 'asc' | 'desc';

/**
 * Query parameters shared by every paginated list endpoint.
 *
 * @remarks
 * `limit` is capped at 50 server-side. The SDK clamps it client-side and warns
 * once so the truncation is never silent.
 *
 * `startDate`/`endDate` filter on `transactionTime` for transactions and on
 * `createdAt` for every other resource.
 */
export interface ListParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: SortOrder;
  search?: string;
  startDate?: string | Date;
  endDate?: string | Date;
  /** Serialized to a JSON string — the backend runs `JSON.parse` on it. */
  filters?: Record<string, unknown>;
}

/** Maximum page size the backend will honour (`BaseService.DEFAULT_LIMIT`). */
export const MAX_PAGE_SIZE = 50;

export interface RequestOptions {
  signal?: AbortSignal;
  timeoutMs?: number;
  headers?: Record<string, string>;
}
